"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/defineProperty"));

var _echarts = _interopRequireDefault(require("@/lib/echarts"));

var _resize = _interopRequireDefault(require("../mixins/resize"));

//
//
//
//
var _default = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    chartLabel: {
      type: Array,
      required: true
    },
    chartTitle: {
      type: String,
      required: false
    },
    isPercent: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    staticLabels: function staticLabels() {
      return [this.$t("dashboard.sun"), this.$t("dashboard.mon"), this.$t("dashboard.tue"), this.$t("dashboard.wed"), this.$t("dashboard.thu"), this.$t("dashboard.fri"), this.$t("dashboard.sat")];
    },
    labels: function labels() {
      var date = new Date();
      var index = date.getDay();
      return this.staticLabels.slice(index).concat(this.staticLabels.slice(0, index));
    }
  },
  watch: {
    locale: function locale(_locale) {
      this.initChart();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, "macarons");
      this.chart.clear();
      this.setOptions(this.chartData);
    },
    setOptions: function setOptions(_ref) {
      var rateSuccessForSevenDays = _ref.rateSuccessForSevenDays,
          receiptSuccessForSevenDays = _ref.receiptSuccessForSevenDays;
      this.chart.setOption({
        title: {
          text: this.chartTitle,
          show: true,
          top: 0,
          left: 0,
          z: 1,
          zLevel: 1,
          textStyle: {
            color: '#000'
          },
          borderRadius: [5, 5, 0, 0]
        },
        xAxis: (0, _defineProperty2.default)({
          data: this.chartLabel,
          boundaryGap: false,
          axisTick: {
            show: true
          },
          axisLine: {
            show: false
          }
        }, "boundaryGap", ['10%', '10%']),
        grid: {
          left: 10,
          right: 30,
          bottom: 20,
          top: 60,
          z: 0,
          zLevel: 0,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          formatter: "{b0} <br /> ".concat(this.$t("dashboard.rateSuccess"), " : {c0}% <br /> ").concat(this.$t("dashboard.receiptSuccess"), " : {c1}%"),
          padding: [5, 10]
        },
        yAxis: {
          min: 0,
          max: 100,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value}%'
          }
        },
        legend: {
          data: [this.$t("dashboard.rateSuccessForSevenDays"), this.$t("dashboard.receiptSuccessForSevenDays")],
          right: 0,
          top: 0
        },
        series: [{
          name: this.$t("dashboard.rateSuccessForSevenDays"),
          itemStyle: {
            normal: {
              color: "#b3404a",
              lineStyle: {
                color: "#b3404a",
                width: 2
              }
            }
          },
          smooth: false,
          type: "line",
          data: this.chartData.rateSuccessForSevenDays,
          animationDuration: 2800,
          animationEasing: "cubicInOut",
          symbolSize: 10,
          symbol: 'circle'
        }, {
          name: this.$t("dashboard.receiptSuccessForSevenDays"),
          smooth: false,
          type: "line",
          itemStyle: {
            normal: {
              color: "#2d527c",
              lineStyle: {
                color: "#2d527c",
                width: 2
              },
              areaStyle: {
                color: "#cee8fa"
              }
            }
          },
          data: this.chartData.receiptSuccessForSevenDays,
          animationDuration: 2800,
          animationEasing: "quadraticOut",
          symbolSize: 10,
          symbol: 'circle'
        }]
      });
    }
  }
};
exports.default = _default;